import React from 'react';
import styled from 'styled-components';
import {
  BREAKPOINT_SMALL,
  DEFAULT_DESKTOP_PADDING,
  DEFAULT_MOBILE_PADDING,
  MarketingHeading1,
  MAX_WIDTH,
} from 'components/MarketingPagesShared/styles';
import { CDN_PATH } from '../../constants';

export const HeroTitle = styled(MarketingHeading1)`
  margin: 0;
  padding: 0;
  padding: ${DEFAULT_DESKTOP_PADDING / 2}px ${DEFAULT_DESKTOP_PADDING}px;
  color: white;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    padding: ${DEFAULT_MOBILE_PADDING * 2}px ${DEFAULT_MOBILE_PADDING}px;
  }
`;

export const FeaturesHeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: ${MAX_WIDTH}px;
  margin: 0 auto;
  text-align: center;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    text-align: left;
  }
`;

export const HeroBackgroundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-image: url('${CDN_PATH}/hero-bg.svg');
  background-repeat: repeat-x;
  background-position: center 45%;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    background-size: 1000px;
  }
`;

export const HeroPhoneContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 350px;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    padding: 0 50px;
  }
`;

export const HeroPhoneRecording = styled.div`
  position: absolute;
  top: 64px;
  left: 50%;
  transform: translateX(-50%);
  user-select: none;

  & > span {
    margin-left: 8px;
    font-size: 21px;
    font-family: inherit;
    font-weight: 900;
    color: white;
  }
`;

export const RecordingIndicatorSVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle fill="#f66181" fillRule="nonzero" cx="8" cy="8" r="8" />
  </svg>
);
